export const REGISTRATION_AUTH_REQUEST = 'REGISTRATION_AUTH_REQUEST';
export const REGISTRATION_AUTH_SUCCESS = 'REGISTRATION_AUTH_SUCCESS';

export const REGISTRATION_TEACHER_PAY_REQUEST = 'REGISTRATION_TEACHER_PAY_REQUEST';
export const REGISTRATION_STUDENT_PAY_REQUEST = 'REGISTRATION_STUDENT_PAY_REQUEST';
export const REGISTRATION_PAY_SUCCESS = 'REGISTRATION_PAY_SUCCESS';

export const LOGIN_AUTH_REQUEST = 'LOGIN_AUTH_REQUEST';

export const AUTH_SUCCESS = 'AUTH_SUCCESS';

export const LOGIN_INIT_REQUEST = 'LOGIN_INIT_REQUEST';
export const LOGIN_INIT_SUCCESS = 'LOGIN_INIT_SUCCESS';

export const LOGIN_RESET_STATE_REQUEST = 'LOGIN_RESET_STATE_REQUEST';
export const LOGIN_RESET_STATE_SUCCESS = 'LOGIN_RESET_STATE_SUCCESS';

export const LOGIN_AUTH_REFRESH_REQUEST = 'LOGIN_AUTH_REFRESH_REQUEST';
export const LOGIN_AUTH_REFRESH_SUCCESS = 'LOGIN_AUTH_REFRESH_SUCCESS';

export const LOGIN_AUTH_UPDATE_ACCESS = 'LOGIN_AUTH_UPDATE_ACCESS';

export const LOGIN_LOGOUT_REQUEST = 'LOGIN_LOGOUT_REQUEST';

export const LOGIN_RESTORE_REQUEST = 'LOGIN_RESTORE_REQUEST';

export const AUTH_AS_USER_REQUEST = 'AUTH_AS_USER_REQUEST';
